import React, { memo } from 'react'
import styles from './Header.module.scss'
import { useNavigate } from "react-router-dom";
import useWindowDimensions, { CurrentScreen } from '../../../hooks/use-window-dimensions';
import { ApplicationRoutes } from '../../../routes';

type Props = {}

const Header: React.FC<Props> = memo((props: Props) => {
  const navigate = useNavigate();

  const currentScreen: CurrentScreen = useWindowDimensions();

  const routeChange = () => {
    navigate(ApplicationRoutes.LANDING_PAGE);
  }

  const navigateToPartnerSignUp = () => {
    navigate(ApplicationRoutes.PROVIDER_SIGNUP);
  }

  return (
    <div className={styles.container}>
      <img onClick={routeChange} src="../../../../images/landing-page-header-icon.png" alt='Logo' />
      {
        !currentScreen.isMobile && <div className={styles.links}>
          <div className={styles.link}>
            About
          </div>
          <div className={styles.link} onClick={navigateToPartnerSignUp}>
            Partners
          </div>
        </div>
      }

    </div>
  )
})

export default Header